import Box from "@/components/Box";
import Circle from "@/components/Circle";
import { theme } from "@/core/theme";
import { CMP_SHOP_URL } from "@/core/urls";
import useCmpRelatedUrl from "@/hooks/organisations/useCmpRelatedUrl";
import BloodIcon from "@/images/BloodIcon";
import Group from "@/tpo/Group";
import LinkWrapper from "@/tpo/LinkWrapper";
import Stack from "@/tpo/Stack";
import ButtonV2 from "@/v2/Buttons";

import {
  dashboardActionButtonSize,
  dashboardHeaderIconSize,
  dashboardHeaderRowGap,
  dashboardInnerStackGap,
  dashboardSectionBody,
  dashboardSectionTitle,
  lhDashboardBp
} from "./dashboardLayout";

export default function ExploreTestsSection() {
  const { resolvedUrls } = useCmpRelatedUrl();

  return (
    <Stack gap={dashboardInnerStackGap} bg="white" borderRadius={20} p={40}>
      <Group gap={dashboardHeaderRowGap} alignItems="center" width="100%" minWidth={0}>
        <Circle bg="transparent" size={lhDashboardBp(60, 52, 60)} border="2px solid black">
          <BloodIcon size={dashboardHeaderIconSize} withCircle={false} color={theme.colors.dark} />
        </Circle>
        <Box {...dashboardSectionTitle} fontSize={lhDashboardBp(28, 24, 36)} flex="1 1 0">
          Explore Tests, Reports & Supplements
        </Box>
      </Group>
      <Box {...dashboardSectionBody} maxWidth={lhDashboardBp(null, null, 720)}>
        Take your learning forward with the tests and reports featured across our courses, events &
        webinars.
      </Box>
      <ButtonV2
        withChevron
        color="dark"
        size={dashboardActionButtonSize}
        as={LinkWrapper}
        to={resolvedUrls[CMP_SHOP_URL]}
        sx={{ alignSelf: "flex-start" }}
      >
        see all tests
      </ButtonV2>
    </Stack>
  );
}
